import template from './auditprogramdrgchanges.html';
import controller from './auditprogramdrgchanges.controller';
import './auditprogramdrgchanges.styl';

let auditprogramdrgchangesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default auditprogramdrgchangesComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogramdrgchanges/auditprogramdrgchanges.component.js